import GenericTopPostsDrawer from './GenericTopPostsDrawer';
import { getCategoryTopPosts } from 'utils/api/instagram.api';

const CategoryTopPostsDrawer = ({
    year,
    week,
    categories,
    countries,
    name,
    displayQty,
}) => {
    const queryParams = {
        category: categories || null,
        country: countries || null,
        page: 1,
        per_page: 500,
    };
    return (
        <GenericTopPostsDrawer
            year={year}
            week={week}
            name={name}
            displayQty={displayQty}
            queryFn={getCategoryTopPosts}
            queryParams={queryParams}
        />
    );
};

export default CategoryTopPostsDrawer;
